export default "__VITE_ASSET__0D4wYzPY__"